import { render, staticRenderFns } from "./OutsideMannersCard.vue?vue&type=template&id=3438b4b0&scoped=true&"
import script from "./OutsideMannersCard.vue?vue&type=script&lang=js&"
export * from "./OutsideMannersCard.vue?vue&type=script&lang=js&"
import style0 from "./OutsideMannersCard.vue?vue&type=style&index=0&id=3438b4b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3438b4b0",
  null
  
)

export default component.exports